import React from 'react';
import { Link } from 'react-scroll';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <img src="/Images/victor charles icon.jpeg" alt="Victor Charles" className="footer-logo-icon" />
            <span>Victor Charles</span>
          </div>
          <p className="footer-text">
            Transforming business challenges into growth opportunities
          </p>
          <div className="footer-links">
            <Link to="home" smooth={true} duration={500}>Home</Link>
            <Link to="services" smooth={true} duration={500}>Services</Link>
            <Link to="solutions" smooth={true} duration={500}>Solutions</Link>
            <Link to="about" smooth={true} duration={500}>About</Link>
            <Link to="contact" smooth={true} duration={500}>Contact</Link>
          </div>
          <div className="footer-divider"></div>
          <p className="footer-bottom">
            &copy; {currentYear} Victor Charles. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
